import { useMelwaysInfo } from '@seek/melways-react';
import { useMatch as useMatchRaw } from 'react-router-dom';

// Polyfill optional path segments for useMatch
// https://github.com/remix-run/react-router/discussions/9862
const useMatch = (pattern: string) => {
  const { language } = useMelwaysInfo();
  const patternWithLang = pattern.replace(
    '/:lang?',
    language === 'en' || language === undefined ? '' : `/${language}`,
  );

  return useMatchRaw(patternWithLang);
};

export { useMatch };
